import kebabCase from 'lodash/kebabCase';

function normalizeAccessor(accessor) {
    return typeof accessor === 'function' ? accessor() : accessor;
}

function getColumnKey(accessor, index) {
    const selector = normalizeAccessor(accessor);

    return `${kebabCase(selector)}-${index}`;
}

function getFirstDefined(...args) {
    for (let i = 0; i < args.length; i += 1) {
        if (args[i] !== undefined && args[i] !== null) {
            return args[i];
        }
    }

    return args[0];
}

function scrollToQuestion(previousIsActive, currentIsActive, fieldRef) {
    if (!previousIsActive && currentIsActive) {
        const node = fieldRef.current;
        const nodePos = node.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const position = (window.pageYOffset + nodePos.top) -
            ((windowHeight - nodePos.height) / 2);

        window.scrollTo({
            top: position,
            left: 0,
            behavior: 'smooth',
        });
    }
}

const exports = {
    getColumnKey,
    getFirstDefined,
    normalizeAccessor,
    scrollToQuestion,
};

export default exports;
